module.exports = __webpack_public_path__ + "img/info-icon.81c84332.svg";